module.exports = __webpack_public_path__ + "static/media/icon-dropdown.6d62b9e1.svg";